<template>
  <el-dialog v-model="showDialog" :title=title :width=width :destroy-on-close=destroyOnClose :close-on-press-escape="!isQiang" :close-on-click-modal="!isQiang" :show-close="!isQiang">
    <div class="formDialog">
      <div class="body">
        <slot></slot>
      </div>
      <div class="actions">
        <el-button v-if="confirmBtnText != ''" type="primary" :loading="loading" @click="submit">{{ confirmBtnText }}</el-button>
        <el-button v-if="!isQiang" type="default" @click="close">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  title: String,
  width: {
    type: String,
    default: '40%'
  },  
  destroyOnClose: {
    type: Boolean,
    default: false
  },
  confirmBtnText: {
    type: String,
    default: "提交"
  },
  isQiang: {
    type: Boolean,
    default: false
  }
})

const showDialog = ref(false)
const loading = ref(false)
const showLoading = () => loading.value = true
const hideLoading = () => loading.value = false
const open = () => showDialog.value = true
const close = () => showDialog.value = false
const emit = defineEmits(['submit'])
const submit = () => emit('submit')

defineExpose({
  open,
  close,
  showLoading,
  hideLoading
})

</script>

<style scoped>
.actions {
  text-align: right;
}
</style>
